<template>
  <div class="custom-select" @blur="open = false">
    <div
      class="custom-select__selected"
      :class="{ open: open }"
      @click="open = !open"
      v-html="selected ? selected : 'Valitse'"
    ></div>
    <div class="custom-select__items" :class="{ selectHide: !open }">
      <div
        v-for="(opt, i) in options"
        :key="i"
        @click="
          open = false;
          $emit('input', opt);
        "
        class="custom-select__item"
      >
        {{ opt.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss">
@mixin base {
  border-bottom-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
  /* box-shadow: $shadow_sm; */
  padding: 1rem 2rem;
  background: white;
}
@mixin baseFont {
  color: $lightred;
  text-align: center;
}

.custom-select {
  position: relative;
  display: flex;
  flex-direction: column;
  &__selected {
    position: relative;
    width: 15rem;
    @include base();
    @include baseFont();
    font-weight: 500;
    user-select: none;
    cursor: pointer;
  }

  &__selected:after {
    content: "";
    position: absolute;
    top: 45%;
    left: 1.25rem;
    padding: 3px;
    border: solid $lightred;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg) translateY(-50%);
  }

  &__items {
    position: absolute;
    top: 3rem;
    width: 15rem;
    @include base();
    overflow: hidden;
  }

  &__item {
    @include baseFont();
    cursor: pointer;
    font-size: 1.4rem;
    padding: 5px 0;
    border-bottom: 1px solid $whitegray;
    user-select: none;
    &:last-child {
      border-bottom: 0;
    }
  }

  .selectHide {
    display: none;
  }
}
</style>
